//Node Modules
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RichText } from 'prismic-reactjs';

// Themes
import theme from '@/themes/index';

const getIcon = type => {
  const iconType = type.toLowerCase().replace(/\s/g, '');

  switch (iconType) {
    case 'number':
      return ['fa', 'phone'];
    case 'whatsapp':
      return ['fab', 'whatsapp'];
    case 'e-mail':
      return ['fa', 'envelope'];
    case 'address':
      return ['fa', 'map']
    default:
      return null;
  }
}

const ContactInformationItem = ({
  content: {
    type,
    contactValue,
    extraInformation,
  },
}) => {
  const icon = getIcon(type);

  return (
    <>
      <div className='contact-information-item'>
        <div>{icon && <FontAwesomeIcon icon={icon} className='icon' />} <span className='type'>{type}</span></div>
        <div className='value'>
          <RichText render={contactValue} />
        </div>
        {extraInformation && <div className='additional-info'>{extraInformation}</div>}
      </div>
      <style jsx>{`
      div.contact-information-item {
        font-family: ${theme.fontFamilies.montserrat};
        font-size: 1.5rem;
        width: 100%;
        margin-bottom: 2.5rem;
        padding: 0 5px;
      }

      div.contact-information-item div span.type {
        margin-left: 0.8rem;
      }

      div.contact-information-item div.value {
        margin-top: 1.938rem;
        font-family: ${theme.fontFamilies.montserrat};
        font-size: 1.25rem;
      }

      div.contact-information-item div.additional-info {
        font-size: 1rem;
        margin-top: 1.5rem;
      }

      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        div.contact-information-item {
          flex: 1 1 20rem;
        }
      }

      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        div.contact-information-item {
          flex: 1;
          margin-top: 0;
          width: 25%;
          margin-top: 2.5rem;
        }
      }
    `}</style>
      <style global jsx>{`
      div svg.icon {
        display: inline-block;
        vertical-align: middle;
        width: 1.3123rem;
      }
    `}</style>
    </>
  )
};

export default ContactInformationItem;